<template>
  <!-- Halaman penuh (tanpa sidebar/header aplikasi) agar Pemberitahuan Privasi bisa dibaca kapan saja -->
  <v-main class="privacy-page">
    <v-container class="privacy-page__container py-6 py-md-10">
      <v-card outlined class="pa-5 pa-md-10">
        <div class="d-flex align-center mb-5">
          <div class="privacy-page__icon mr-4">
            <v-icon color="white">{{ iconShield }}</v-icon>
          </div>
          <div>
            <h1 class="privacy-page__title">Pemberitahuan Privasi (Privacy Notice)</h1>
            <div class="privacy-page__subtitle">Aplikasi ELEMEN · PT Perkebunan Nusantara IV (PalmCo)</div>
          </div>
        </div>
        <v-divider class="mb-5"></v-divider>
        <privacy-notice-content />
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import { mdiShieldCheckOutline } from "@mdi/js";
import PrivacyNoticeContent from "@/components/commonComponents/PrivacyNoticeContent.vue";

export default {
  name: "PrivacyNotice",
  components: { PrivacyNoticeContent },
  data: () => ({
    iconShield: mdiShieldCheckOutline,
  }),
};
</script>
<style>
.privacy-page {
  background: #f5f5f5;
  min-height: 100vh;
}

.privacy-page__container {
  max-width: 1024px !important;
}

.privacy-page__icon {
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
}

.privacy-page__title {
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.35;
  color: #1a1a1a;
}

.privacy-page__subtitle {
  font-size: 0.9rem;
  color: #666;
}
</style>
